import { Button, Container, Grid, Typography } from "@mui/material";
import { t } from "i18next";
import React, { Component, ErrorInfo, ReactNode } from "react";

type Props = { children: ReactNode };
type State = { hasError: boolean; message?: string; type?: string };

class ErrorBoundary extends Component<Props, State> {

    state: State = { hasError: false };

    static getDerivedStateFromError(error: Error) {
        return {
            hasError: true,
            message: error.message,
            type: error.name,
        };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error("React error boundary caught:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Container maxWidth="md">
                    <Grid item container
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        height="100vh"
                        textAlign="center"
                    >
                        <Typography variant="bodyMedium" fontWeight="600" color="error.main">
                            {this.state.type || "Error"}
                        </Typography>
                        <Typography sx={{ fontSize: { xs: "40px", lg: "60px" } }} fontWeight="600" mb={2} mt={1}>
                            {t("dashboard.something_went_wrong", "Something went wrong")}
                        </Typography>
                        <Typography variant="bodyLarge" color="textSecondary" mb={6}>
                            {t("global.unexpected_error", "An unexpected error occurred while processing your request. Please reload the page. If this issue persists, contact your system administrator or support team.")}
                        </Typography>
                        <Grid item display="flex" gap={2}>
                            <Button variant="outlined" color="primary" onClick={() => window.location.reload()}>
                                {t("global.reload_page", "Reload page")}
                            </Button>
                            <Button variant="contained" color="primary" onClick={() => (window.location.href = "/")}>
                                {t("global.go_to_home", "Go to home")}
                            </Button>
                        </Grid>
                    </Grid>

                </Container>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
